import {defineStore} from 'pinia'
import CustomStore from "devextreme/data/custom_store";
import _ from "lodash";
import axios from "axios";
import {API_BASE_URL} from "@/global-constants";
import api from "@/api";
export const useGajiListModel  = defineStore(
    'gajiListModel',
    () => {
    const columns = ['gajis','simpeg_pegawais', 'riwayat_pekerjaans', 'cabangs', 'units', 'pegawai_statuses',  
        'sub_bagians', 'bagians', 'bidangs', 'sub_bidangs', 'seksis', 'golongans', 'jabatans', 'absen_bulans', 'pphs'];


        function convertColumnName(name, columns) {
            for (const column of columns) {
                const pattern = new RegExp(`^${column}_`);
                if (pattern.test(name)) {
                    return name.replace(pattern, `${column}.`);
                }
            }
            return name;
        }
        
        function convertArrayElements(arr, columns) {
            return _.map(arr, element => {
                if (_.isArray(element)) {
                    return convertArrayElements(element, columns);
                } else if (_.isString(element)) {
                    return convertColumnName(element, columns);
                }
                return element;
            });
        }

        const findArrayWithKey = (arr, key) => {
            if (_.isArray(arr)) {
                // Check if the current array has the key as the first element
                if (_.isArray(arr[0]) && arr[0][0] === key) {
                    return arr[0]; // Return the found array
                }else{
                    if(arr[0] === key){
                        return arr;
                    }
                }
                // Recursively check each element of the array
              
                for (let element of arr) {
                    const result = findArrayWithKey(element, key);
                    if (result) {
                        return result; // Return if found
                    }
                }
            }
            return null; // Return null if not found
        };

        



        const gajiListCustomStore = new CustomStore({
            key: 'gajis_id',
            insert: async (values) => {
              
                values = convertArrayTgl(values);


               try {
                const response = await axios.post(`${API_BASE_URL}/customstore-gajis/insert`, {values: values}, {
                        headers: {
                            Authorization: api.defaults.headers.common['Authorization'],
                            'Content-Type': 'application/json',
                        },
                    });
                    if (response.data) {
                        return response.data.data;
                    }
                } catch (error) {
                    console.error('Insert error:', error);
                    throw JSON.stringify(error.response.data.message, null, 2);
                }
            },

            update: async (key, values) => {
                values = convertArrayTgl(values);

               try {
                const response = await axios.post(`${API_BASE_URL}/customstore-gajis/insert`, {values : values, id : key}, {
                    headers: {
                        Authorization: api.defaults.headers.common['Authorization'],
                        'Content-Type': 'application/json',
                    },
                });
                if (response.data) {
                    return response.data.data;
                }
                } catch (error) {
                    console.error('Insert error:', error);
                    throw JSON.stringify(error.response.data.message, null, 2);
            
                }
            },

            remove: async(key) => {
                try {
                    const response = await axios.delete(`${API_BASE_URL}/customstore-gajis/${key}`, {
                        headers: {
                            Authorization: api.defaults.headers.common['Authorization'],
                            'Content-Type': 'application/json',
                        },
                    });
                    if (response.data) {
                        return true;
                    }
                } catch (error) {
                    console.error('Insert error:', error);
                    throw JSON.stringify(error.response.data.message, null, 2);
                }
            },

            load: async (loadOptions) => {
                let params = {};
                params.sort = "";params.filter=""; params.pegawaiStatusId="";
               
                const findDewas = findArrayWithKey(loadOptions.filter, 'dewas_gajis_dewas_id');
                if(findDewas){
                    return {
                        data: [],
                        totalCount: 0,
                        summary: []
               
                    };
                }
                // const findPegawaiStatusId = findArrayWithKey(loadOptions.filter, "gajis_pegawai_status_id");
                // console.log("debug gajilistmodel find pegawaistatus",findPegawaiStatusId); 
                // if(findPegawaiStatusId){ params.pegawaiStatusId = findPegawaiStatusId[2];}
              
               
                if(loadOptions.totalSummary){
                    params.summary = loadOptions.totalSummary.map(summaryItem => summaryItem.selector);
                }
                if (loadOptions.sort) {
                    if (typeof loadOptions.sort[0].selector === 'function') {
                        loadOptions.sort[0].selector= loadOptions.sort[0].selector.context.column.dataField;
                    }
                    params.sort = JSON.stringify(convertArrayElements(loadOptions.sort, columns));
                }
               
                
                if (loadOptions.filter) {
                    loadOptions.filter = processLoadArray(loadOptions.filter); //benerin format tanggal
                    let temp = [];
                    
                    temp = convertArrayElements(loadOptions.filter, columns)
                    params.filter = JSON.stringify(temp);

                }


               // ================FILTER DEFAULT --> filter pegawai yang aktif
                loadOptions.filterDefault = [];
                // loadOptions.filterDefault = ['show', '=', true];
                if(params.filter === ""){
                    // loadOptions.filterDefault.push(['simpeg_pegawais.status_aktif_id', '=', '1']);
                }
               
                params.filterDefault = JSON.stringify(loadOptions.filterDefault );

                //================SORT DEFAULT --> sort jabatan_id asc, nik
                loadOptions.sortDefault = [];
                // if(!params.sort.includes("jabatans.nama")){
                //     loadOptions.sortDefault.push({"selector":"jabatans.id","desc":false});
                // }
                // if(!params.sort.includes("nik")){
                //     loadOptions.sortDefault.push({"selector":"nik","desc":false});
                // }
                
                var hasOnlyGajisId = false;
                if(loadOptions.sort)
                 hasOnlyGajisId = loadOptions.sort.length === 1 && _.get(loadOptions.sort[0], 'selector') === 'gajis_id';
               
                if(params.sort === "" || hasOnlyGajisId){
                    loadOptions.sortDefault.push({"selector":"tgl_gaji","desc":true});
                    // loadOptions.sortDefault.push({"selector":"jabatans_id","desc":false});
                    loadOptions.sortDefault.push({"selector":"jabatans.id","desc":false});
                    loadOptions.sortDefault.push({"selector":"simpeg_pegawais.nik","desc":false});

                    //untuk honor and kontrak, order using tgl_mulai_bekerja
                    // Regular expression to match "gajis.pegawai_status_id","=", followed by 4 or 5
                    const regex = /"gajis\.pegawai_status_id","=",([45])/;
                    if(params.filter.match(regex)){
                        loadOptions.sortDefault.push({"selector":"simpeg_pegawais.tgl_mulai_bekerja","desc":false});
                    }
                    
                    loadOptions.sortDefault.push({"selector":"simpeg_pegawais.nama","desc":false});
                   
                    params.sort = "";
                }
               
                    
                params.sortDefault = JSON.stringify(loadOptions.sortDefault );

                ////////////////////////////////////

                if (loadOptions.skip) {
                    params.skip = loadOptions.skip;
                }

                if (loadOptions.take) {
                    params.take = loadOptions.take;
                }

               

                const response = await axios.get(`${API_BASE_URL}/customstore-gajis`, {
                    params: params,
                    headers: {
                        Authorization: api.defaults.headers.common['Authorization'],
                        'Content-Type': 'application/json',
                    },
                });

                
               
          
              
                if (response.data) {
                    return {
                        data: response.data.data,
                        totalCount: response.data.totalCount,
                        summary: response.data.summary
               
                    };
                }

                throw 'Data loading error';
            },
        });


          
       

        function processLoadArray(loadArray) {
            return _.map(loadArray, item => {
                if (_.isArray(item)) {
                    // Check if 'periode_absen' is present in the sub-array
                    if (_.includes(item, 'tgl_mulai_bekerja') || _.includes(item, 'tgl_lahir') || _.includes(item, 'pensiun_tgl') || _.includes(item, 'tgl')) {
                        // Map through the sub-array to find and convert Date objects
                        return _.map(item, subItem => {
                            return subItem instanceof Date ? formatDateToISOString(subItem) : subItem;
                        });
                    } else {
                        // Recursively process nested arrays
                        return processLoadArray(item);
                    }
                }
                return item;
            });
        }

        function convertArrayTgl(loadArray) {
            
            _.forEach(loadArray, (item, index) => {
               
                if(item instanceof Date){
                   
                     loadArray[index]= formatDateToISOString(item);
                }
                
              });

              return loadArray;
        }

        


        function formatDateToISOString(date) {
            function pad(n) { return n < 10 ? '0' + n : n }
            return date.getFullYear() + '-' +
                pad(date.getMonth() + 1) + '-' +
                pad(date.getDate());
        }


        return {
            gajiListCustomStore,
           
        }
    });